import React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { UseEditProjectAssumptionCategory } from "../../../hooks/Admin";

const EditAssumptionCategory = ({
  setOpen,
  open,
  categoryID,
  categoryEdit,
  setCategoryEdit,
}) => {
  const EditAssumptionCategoryMutation = UseEditProjectAssumptionCategory(() =>
    setOpen(false)
  );

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={"md"}
      fullWidth={true}
      PaperProps={{
        component: "form",
        onSubmit: (event) => {
          event.preventDefault();
          const data = {
            id: categoryID,
            assData: {
              assumption_category: {
                name: categoryEdit,
              },
            },
          };
          EditAssumptionCategoryMutation.mutate(data);
        },
      }}
    >
      <DialogTitle>EDIT CATEGORY</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          required
          margin="dense"
          id="name"
          name="Category"
          label="Category"
          type="text"
          fullWidth
          variant="standard"
          value={categoryEdit}
          onChange={(e) => {
            setCategoryEdit(e.target.value);
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="contained" color="error">
          Cancel
        </Button>
        <Button
          type="submit"
          color="secondary"
          variant="contained"
          disabled={EditAssumptionCategoryMutation.isLoading}
        >
          Edit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditAssumptionCategory;
